/**
 * BuyerJourneyObservability (AJIP-16.02.007 · WS17)
 * 18 internal event kinds. Same emitter pattern.
 */
const BUYER_JOURNEY_EVENTS = Object.freeze({
  BUYER_JOURNEY_REGISTRATION_CONFIRMED: 'BUYER_JOURNEY_REGISTRATION_CONFIRMED',
  BUYER_JOURNEY_DISCOVERY_REQUESTED: 'BUYER_JOURNEY_DISCOVERY_REQUESTED',
  BUYER_JOURNEY_ELIGIBILITY_EVALUATED: 'BUYER_JOURNEY_ELIGIBILITY_EVALUATED',
  BUYER_JOURNEY_RESOLUTION_REQUESTED: 'BUYER_JOURNEY_RESOLUTION_REQUESTED',
  BUYER_JOURNEY_RESOLUTION_COMPLETED: 'BUYER_JOURNEY_RESOLUTION_COMPLETED',
  BUYER_JOURNEY_ACTIVATION_REQUESTED: 'BUYER_JOURNEY_ACTIVATION_REQUESTED',
  BUYER_JOURNEY_ACTIVATED: 'BUYER_JOURNEY_ACTIVATED',
  BUYER_JOURNEY_ACTIVATION_REJECTED: 'BUYER_JOURNEY_ACTIVATION_REJECTED',
  BUYER_JOURNEY_STAGE_TRANSITIONED: 'BUYER_JOURNEY_STAGE_TRANSITIONED',
  BUYER_JOURNEY_PAUSED: 'BUYER_JOURNEY_PAUSED',
  BUYER_JOURNEY_RESUMED: 'BUYER_JOURNEY_RESUMED',
  BUYER_JOURNEY_PERSISTED: 'BUYER_JOURNEY_PERSISTED',
  BUYER_JOURNEY_RESTORATION_REQUESTED: 'BUYER_JOURNEY_RESTORATION_REQUESTED',
  BUYER_JOURNEY_RESTORED: 'BUYER_JOURNEY_RESTORED',
  BUYER_JOURNEY_BLOCKED: 'BUYER_JOURNEY_BLOCKED',
  BUYER_JOURNEY_CANCELLED: 'BUYER_JOURNEY_CANCELLED',
  BUYER_JOURNEY_FAILED: 'BUYER_JOURNEY_FAILED',
  BUYER_JOURNEY_COMPLETED: 'BUYER_JOURNEY_COMPLETED',
});
const ALL_BUYER_JOURNEY_EVENTS = Object.freeze(Object.values(BUYER_JOURNEY_EVENTS));

class BuyerJourneyObservability {
  constructor() {
    this._handlers = new Map();
    for (const k of ALL_BUYER_JOURNEY_EVENTS) this._handlers.set(k, new Set());
    this._enabled = true;
  }
  on(kind, handler) {
    if (!ALL_BUYER_JOURNEY_EVENTS.includes(kind) || typeof handler !== 'function') return () => {};
    this._handlers.get(kind).add(handler);
    return () => this._handlers.get(kind).delete(handler);
  }
  emit(kind, payload) {
    if (!this._enabled || !ALL_BUYER_JOURNEY_EVENTS.includes(kind)) return 0;
    let count = 0;
    for (const h of this._handlers.get(kind)) {
      try { h(Object.freeze({ event: kind, at: Date.now(), payload })); count += 1; } catch (_e) { /* isolate */ }
    }
    return count;
  }
  listenerCount(kind) { return this._handlers.has(kind) ? this._handlers.get(kind).size : 0; }
}

export { BUYER_JOURNEY_EVENTS, ALL_BUYER_JOURNEY_EVENTS, BuyerJourneyObservability };
